import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import AddOperatorForm from "../forms/AddOperatorForm";
import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import ErrorDisplay from "../../../components/UI/ErrorDisplay";

const AddOperatorPage = () => {
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();
  return (
    <MainPageLayout headerConfig={{ title: "Add Operator" }}>
      <div className="form-container ">
        <CenteredHeading title="Add Operator" />
        {formError && (
          <ErrorDisplay
            message={formError}
            closeAction={() => setFormError("")}
          />
        )}
        <AddOperatorForm
          loading={loading}
          executePost={executePost}
          successResponse={successResponse}
        />
      </div>
    </MainPageLayout>
  );
};

export default AddOperatorPage;
